var baseURL
var accessKeyID
var accessKey
var baseContext
var loginUrl
var cloudBaseURL

if (process.env.ENV_CONFIG === 'development' || process.env.ENV_CONFIG === 'test') {
    baseURL = 'http://223.111.8.117:38080/'  
  // baseURL = 'http://betagame.migufun.com/'     //现网
  // baseURL = 'http://172.19.211.82:8080/'

  cloudBaseURL = 'http://223.111.8.111:28080'
  // cloudBaseURL = '/api'
  // 测试
  accessKeyID = '7f64350ef76'
  accessKey = 'a8c14c093f7d0a3c583e2e6a47304d37'
  baseContext = 'http://223.111.8.117:38080/miguplay/'
  loginUrl = 'https://112.13.96.201:10443/login'
} else {
  baseURL = 'https://betagame.migufun.com/'
  // baseURL = 'http://172.19.211.82:8080/'

  cloudBaseURL = 'http://alphagame.migufun.com'
  // beta
  accessKeyID = '1e536667ec3'
  accessKey = '77a626f87a9ceac9b7d8cb03bb899007'
  // alpha
  // accessKeyID = 'D4F92FE4CFC'
  // accessKey = '625a706566676a397432573238557444'
  baseContext = 'http://g.10086.cn/miguplay/'
  loginUrl = 'https://passport.migu.cn/login'

}
export default {
  baseURL: baseURL,
  baseContext: baseContext,
  accessKey: accessKey,
  accessKeyID: accessKeyID,
  loginUrl:loginUrl,
  cloudBaseURL:cloudBaseURL
}



// WEBPACK FOOTER //
// ./src/api/config.js